import { createReducer } from 'redux-starter-kit';
import { putUserGroup } from './companyActions';


/**
 * A selector for the app config loaded in the domain state.
 */
export const selectUserGroup = state => state.via.domain.company.userGroup;

/**
 * Only one user group per user so only one group loaded
 */
const initialCompanyConfiguration = {
  userGroup: undefined,
};

/**
 * A reducer for managing the user group in the domain.
 */
const companyReducer = createReducer(initialCompanyConfiguration, {
  [putUserGroup]: (state, action) => ({
    ...state,
    userGroup: action.payload,
  }),
});

export default companyReducer;
